var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_340",
    "data-name": "Group 340",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.333,
    height: 100,
    viewBox: "0 0 133.333 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 133.333,
    height: 100,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M114.488,0c-.23,0-.459,0-.685,0H6.25A6.247,6.247,0,0,0,2.24,1.471,6.368,6.368,0,0,0,0,5.85V81.64a6.354,6.354,0,0,0,2.392,4.513A6.236,6.236,0,0,0,6.247,87.5H81.9c.521,0,1.039-.01,1.56.013a27.086,27.086,0,0,0,48.429-5.869,27.693,27.693,0,0,0,1.443-7.991V72.315A27.412,27.412,0,0,0,132.8,67.6,26.994,26.994,0,0,0,120.847,50.13c-.024-.52-.01-1.041-.013-1.562V6.25A6.283,6.283,0,0,0,115.171.028C114.947.008,114.718,0,114.488,0ZM6.245,4.167H114.587a2.1,2.1,0,0,1,2.08,2.078c-.008.853.021,1.71-.018,2.562-7.539,5.434-15.078,10.916-22.612,16.362Q78.481,36.436,62.922,47.7a4.172,4.172,0,0,1-4.005.559,7.13,7.13,0,0,1-1.621-1Q30.764,28.054,4.185,8.807c-.039-.852-.01-1.708-.018-2.561A2.1,2.1,0,0,1,6.245,4.167ZM4.177,13.935Q29.3,32.107,54.4,50.3a14.289,14.289,0,0,0,2.614,1.677,8.334,8.334,0,0,0,6.893-.042A14.784,14.784,0,0,0,66.433,50.3Q91.548,32.12,116.657,13.935q.012.389.012.779c-.008,11.066.009,22.14-.009,33.206a27.01,27.01,0,0,0-24.754,2.043c-3.259-1.97-6.5-3.97-9.763-5.94a2.068,2.068,0,0,0-2.116,3.552c2.754,1.678,5.523,3.369,8.278,5.044a28.409,28.409,0,0,0-4.75,5.534,27.035,27.035,0,0,0-2.3,25.176q-37.49.017-75,0a2.1,2.1,0,0,1-2.079-2.078c0-3.775,0-7.566,0-11.338Q22.45,58.786,40.74,47.637a2.1,2.1,0,0,0,.616-3.052A2.073,2.073,0,0,0,38.6,44.06Q21.682,54.365,4.767,64.676a2.15,2.15,0,0,0-.6.432q-.009-24.537,0-49.093C4.172,15.322,4.157,14.628,4.177,13.935ZM106.056,50q.812-.005,1.625.049A22.732,22.732,0,1,1,106.056,50Z",
    transform: "translate(0 0)",
    fill: "#e89d18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M163.5,98.946a2.267,2.267,0,0,1,1.539.8q5.1,5.112,10.221,10.226a2.1,2.1,0,0,1-.066,3.009q-5.178,5.17-10.355,10.35a2.083,2.083,0,0,1-3.535-1.738,2.159,2.159,0,0,1,.656-1.274c2.27-2.255,4.518-4.536,6.8-6.781-6.349-.031-12.71,0-19.062-.013a3.829,3.829,0,0,1-1.855-.232,2.079,2.079,0,0,1,.942-3.933c6.655-.012,13.32.018,19.974-.015-2.28-2.245-4.526-4.526-6.8-6.781a2.087,2.087,0,0,1,1.539-3.619Z",
    transform: "translate(-57.122 -38.524)",
    fill: "#c44042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M93.664,48.158c-.409.345-5.053,6.308-7.4,9.214a16.6,16.6,0,0,0,15.02.2c-2.286-2.817-7.149-9.063-7.57-9.417Z",
    transform: "translate(-33.587 -18.751)",
    fill: "#c44042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M71.467,28.233a16.639,16.639,0,0,0,3.465,10.159c2.046-1.339,7.152-4.98,9.167-9.235a9.216,9.216,0,0,1-3.031-6.086c-.135-3.663,3.1-8.382,6.609-8.338.074,0,.151.01.227.015h.048c.076,0,.15-.015.227-.015,3.508-.044,6.744,4.674,6.609,8.338a9.213,9.213,0,0,1-3.032,6.086c2.165,4.568,7.895,8.434,9.57,9.493A16.749,16.749,0,1,0,71.467,28.233",
    transform: "translate(-27.827 -4.468)",
    fill: "#c44042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M97.065,22.06h-.1c-.673,0-2.546-.185-2.1,1.761a16.377,16.377,0,0,0,2.071,4.356c.073.119.139,0,.139,0a16.335,16.335,0,0,0,2.073-4.356c.377-1.635-.887-1.765-1.7-1.765-.153,0-.291,0-.4,0",
    transform: "translate(-36.913 -8.588)",
    fill: "#c44042"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalCardIcon);
export default __webpack_public_path__ + "static/media/digital-card-icon.2756d097db78eb88fd6e53e74305366a.svg";
export { ForwardRef as ReactComponent };